import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet-view_fold",
  "use": "icon-sheet-view_fold-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-sheet-view_fold\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2 9.262l4.243-3.738 4.242 3.738\" /><path d=\"M2 5.738L6.243 2l4.242 3.738\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol